import { gtag } from "client/utils/adsense/gtag";
import { getTaskIdsFromUrlParams } from "client/utils/getTaskIdsFromUrlParams";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { compressSelector } from "store/features/compress/selectors/compressSelector";
import { useAppSelector } from "store/store";
import translatedRoutedSlugs from "translatedRouteSlugs";
import { useUrlTaskIds } from "./useUrlTaskIds";

let hasEffectRan = false;

function routeChangeComplete() {
    hasEffectRan = false;
}

export const useCompressor = (toolPathName: string) => {
    const { fromDownloadPage } = useAppSelector(
        compressSelector,
        (left, right) => left.fromDownloadPage === right.fromDownloadPage,
    );
    const handleEditorLoadedAnalytics = () => {
        ///event
        gtag("event", "Editor Loaded", {
            event_category: "Image Compressor",
            event_label: "Editor Page",
        });
    };
    const { handleUrlTaskIds } = useUrlTaskIds();
    const router = useRouter();

    function buildTranslatedRoute(route: string, locale: string): string {
        if (locale === "en") return route;
        if (!translatedRoutedSlugs[route]) return route;
        if (!translatedRoutedSlugs[route][locale]) return route;
        return `/${locale}/${translatedRoutedSlugs[route][locale]}`;
    }

    useEffect(() => {
        if (hasEffectRan) return;
        hasEffectRan = true;
        const urlTaskIds = getTaskIdsFromUrlParams();
        urlTaskIds.length > 0 && handleUrlTaskIds(urlTaskIds);
        if (!fromDownloadPage && urlTaskIds.length === 0) {
            window.location.href = buildTranslatedRoute(toolPathName, router.locale ?? "en");
        }
        handleEditorLoadedAnalytics();
    }, []);

    useEffect(() => {
        router.events.on("routeChangeComplete", routeChangeComplete);
        return () => router.events.off("routeChangeComplete", routeChangeComplete);
    }, []);
};
